import { useDialogContext } from '../../../contexts/DialogContext';
import { window } from '../../../globals';
import { getAuthorizeServiceURL } from '../../../helpers/services';
import { post } from '../../../redux/api';
import { BUTTON_TYPE, NavigationButton } from '../../generic';
import Button from '../../generic/Button';
import Icon, { icons } from '../../generic/Icon';
import Header from '../../shared/settings/SettingsPageHeader';
import Section from '../../shared/settings/SettingsPageSection';

const BitbucketSettings = () => {
  const { onConfirm } = useDialogContext();

  return (
    <>
      <Header heading="Bitbucket Cloud Login" />
      <Section>
        <Section.Left heading="Bitbucket Cloud Login">
          <Section.Paragraph>
            FOSSA allows users to link a Bitbucket Cloud login to their FOSSA login.
          </Section.Paragraph>
        </Section.Left>
        <Section.Right>
          {!window.user?.bitbucketCloud ? (
            <>
              <h4>You are not connected to Bitbucket</h4>
              <div className="margin-top-lg">
                <NavigationButton
                  to={getAuthorizeServiceURL({
                    vcsHost: 'bitbucket_cloud',
                    location: window.location.href,
                    serviceConnect: true,
                  })}
                  type={BUTTON_TYPE.SECONDARY}
                  openInNewTab
                >
                  <Icon icon={icons.bitbucket} /> Connect to Bitbucket Cloud
                </NavigationButton>
              </div>
            </>
          ) : (
            <>
              <h4>
                You are currently connected{' '}
                {window.user?.bitbucketCloud?.name ? (
                  <span>
                    as <b>{window.user?.bitbucketCloud?.name}</b>
                  </span>
                ) : (
                  <span>to Bitbucket Cloud</span>
                )}
              </h4>
              <div className="margin-top-lg">
                <Button
                  type={BUTTON_TYPE.SECONDARY}
                  onClick={() => {
                    onConfirm({
                      title: 'Confirm Bitbucket Cloud disconnect',
                      body: (
                        <div>
                          <p>
                            <b>
                              Are you sure you want to disassociate the current user with the registered Bitbucket Cloud
                              account?
                            </b>{' '}
                            (cannot be undone)
                          </p>
                        </div>
                      ),
                      onConfirm: async () => {
                        // Send `{}` rather than `null`: the body is unused by the route handler, but body-parser's
                        // strict JSON mode rejects bare `null` with a 400 before the handler runs.
                        await post('/api/services/bitbucket_cloud/disconnectService', {});
                        window.location.reload();
                      },
                    });
                  }}
                >
                  Disconnect
                </Button>
              </div>
            </>
          )}
        </Section.Right>
      </Section>
    </>
  );
};

export default BitbucketSettings;
